/**
 * Permission model
 * @category Permissions
 */
export interface Permission {
  /** Permission id */
  id?: string
  /** Permission title */
  title?: string
  /** Permission created at */
  create_at?: string
}

/**
 * Permission types
 * @category Permissions
 */
export enum PermissionType {
  /** Edit users */
  EDIT_USERS = 'edit_users',
  /** Edit projects */
  EDIT_PROJECTS = 'edit_projects',
  /** Edit roles */
  EDIT_ROLES = 'edit_roles',
  /** Edit project suppliers */
  EDIT_PROJECT_SUPPLIER = 'edit_project_suppliers',
  /** Edit project structure */
  EDIT_PROJECT_SETTINGS = 'edit_project_settings',
  /** Edit the project users */
  EDIT_PROJECT_USERS = 'edit_project_users',
  /** Edit deliveries */
  EDIT_DELIVERIES = 'edit_deliveries',
  /** Edit all deliveries */
  EDIT_ALL_DELIVERIES = 'edit_all_deliveries',
  /** Edit orders */
  EDIT_ORDERS = 'edit_orders',
  /** Edit invoices */
  EDIT_INVOICES = 'edit_invoices',
  /** View invoice evaluations */
  VIEW_INVOICE_EVALUATIONS = 'view_invoice_evaluations',
  /** Edit invoice evaluations */
  EDIT_INVOICE_EVALUATIONS = 'edit_invoice_evaluations',
  /** Edit evaluations */
  EDIT_EVALUATIONS = 'edit_evaluations',
  /** Edit suppliers */
  EDIT_SUPPLIERS = 'edit_suppliers',
  /** Edit contracts */
  EDIT_CONTRACTS = 'edit_contracts',
  /** Edit invoice receipt */
  EDIT_INVOICE_RECEIPT = 'edit_invoice_receipt',
  /** Edit Invoice settings */
  EDIT_INVOICE_SETTINGS = 'edit_invoice_settings',
  /** Edit mappings */
  EDIT_MAPPINGS = 'edit_mappings',
  /** Edit Regions Page */
  EDIT_REGIONS = 'edit_regions',
}

/**
 * Admin permissions
 * @category Permissions
 */
export const ADMIN_PERMISSIONS = {
  ...PermissionType,
}

/**
 * User permissions
 * @category Permissions
 */
export const USER_PERMISSIONS = [
  PermissionType.EDIT_DELIVERIES,
  PermissionType.EDIT_ORDERS,
  PermissionType.EDIT_INVOICES,
  PermissionType.EDIT_PROJECT_SUPPLIER,
  PermissionType.EDIT_PROJECT_SETTINGS,
  PermissionType.EDIT_REGIONS,
]
